<template>
  <div>
    <!-- Tampilkan loader sampai data dari localStorage selesai dimuat -->
    <Loader v-if="!initialized" />
    <MainLayout v-else />

    <!-- Snackbar tetap muncul meskipun sedang loading -->
    <v-snackbar class="mt-5" v-model="snackbarVisible" :color="snackbarColor" :timeout="3000" location="top">
      {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import "@/assets/customSwal.css";
import { useMainStore } from "@/store";
import { computed, onMounted, ref, watch } from "vue";
import Loader from "./components/Loader.vue";
import MainLayout from "./layout/MainLayouts.vue";

export default {
  components: { Loader, MainLayout },
  setup() {
    const store = useMainStore();
    const initialized = ref(false);

    // Tunggu sampai data dari localStorage selesai dimuat
    onMounted(async () => {
      await store.loadFromStorage();
      initialized.value = true;
    });

    const snackbarVisible = ref(false);
    const snackbarMessage = computed(() => store.snackbarMessage);
    const snackbarColor = computed(() => store.snackbarColor || "error");

    watch(snackbarMessage, (val) => {
      snackbarVisible.value = !!val;
    });

    return {
      initialized,
      snackbarVisible,
      snackbarMessage,
      snackbarColor,
    };
  },
};
</script>
